export const isEmpty = (obj?: unknown) => Object.entries(obj || {}).length === 0;
